import { object, bool, array, func, string } from 'prop-types'
import { kuiperClassNames, ApplyStampButton } from '@opallabs/kuiper'
import { AnalyticsLayer } from '@opallabs/quanta'
import ChannelAndAccount from '../ChannelAndAccount'
import PostPlacementsControls from '../PostPlacementsControls'

import './styles.scss'

const PostMetaSelects = ({
  accountId,
  accounts,
  accountTerm = 'account',
  canCreateAccount,
  channels,
  createPostPlacement,
  destroyPostPlacement,
  getPlacements,
  isOpeningPreviewer = false,
  isSaved,
  onAccountSelect,
  onChannelSelect,
  onStampSelect,
  openAccountCreator,
  openPlacementsPreviewer,
  placements,
  post,
  postId,
  reset,
  scheduledAt,
  selectedAccount = {},
  selectedChannel = {},
  stamps,
  takedownScheduledAt,
  triggerDirtyState,
  triggerSaveFinished,
  updatePostPlacement,
  validAccount = false,
  validChannel = false,
}) => (
  <AnalyticsLayer name="Content Composer - Post Sidebar Meta Selects">
    <div className={kuiperClassNames('post-meta-selects')}>
      <PostPlacementsControls
        accountId={accountId}
        accounts={accounts}
        accountTerm={accountTerm}
        canCreateAccount={canCreateAccount}
        createPostPlacement={createPostPlacement}
        destroyPostPlacement={destroyPostPlacement}
        getPlacements={getPlacements}
        isOpeningPreviewer={isOpeningPreviewer}
        isSaved={isSaved}
        onAccountSelect={onAccountSelect}
        openAccountCreator={openAccountCreator}
        openPlacementsPreviewer={openPlacementsPreviewer}
        placements={placements}
        post={post}
        postId={postId}
        reset={reset}
        scheduledAt={scheduledAt}
        selectedAccount={selectedAccount}
        takedownScheduledAt={takedownScheduledAt}
        triggerDirtyState={triggerDirtyState}
        triggerSaveFinished={triggerSaveFinished}
        updatePostPlacement={updatePostPlacement}
        validAccount={validAccount}
      />
      {Boolean(stamps.length) && (
        <ApplyStampButton
          objectName="content"
          onSelect={onStampSelect}
          stamps={stamps}
        />
      )}
      <ChannelAndAccount
        channels={channels}
        onChannelSelect={onChannelSelect}
        selectedChannel={selectedChannel}
        validChannel={validChannel}
      />
    </div>
  </AnalyticsLayer>
)
PostMetaSelects.displayName = 'Photon: PostMetaSelect'

PostMetaSelects.propTypes = {
  accountId: string,
  accounts: array,
  accountTerm: string,
  canCreateAccount: bool,
  channels: array,
  createPostPlacement: func,
  destroyPostPlacement: func,
  getPlacements: func,
  isOpeningPreviewer: bool,
  isSaved: bool,
  onAccountSelect: func.isRequired,
  onChannelSelect: func.isRequired,
  onStampSelect: func.isRequired,
  openAccountCreator: func.isRequired,
  openPlacementsPreviewer: func,
  placements: array,
  post: object,
  postId: string,
  reset: bool,
  scheduledAt: string,
  selectedAccount: object,
  selectedChannel: object,
  stamps: array,
  takedownScheduledAt: string,
  triggerDirtyState: func,
  triggerSaveFinished: func,
  updatePostPlacement: func,
  validAccount: bool,
  validChannel: bool,
}

export default PostMetaSelects
